export class ModbusrtuModel {

  public id?: number;
  public type?: number;
  public typeName?: string;
  public attribute?: number;
  public attributeName?: string;
  public measure?: number;
  public measureName?: string;
  public length?: string;
  public address?: string;
  public multiplier?: number;
  public constoffset?: number;
  public datatype?: number;
  public datatypemodbus?: number;
  public counter?: number;
  public enabled?: boolean;
  public modified?: string;
  public modifiedBy?: string;

  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
      this.type = data.type;
      this.typeName = data.typeName;
      this.attribute = data.attribute;
      this.attributeName = data.attributeName;
      this.measure = data.measure;
      this.measureName = data.measureName;
      this.length = data.length;
      this.address = data.address;
      this.multiplier = data.multiplier;
      this.constoffset = data.constoffset;
      this.datatype = data.datatype;
      this.datatypemodbus = data.datatypemodbus;
      this.counter = data.counter;
      this.enabled = data.enabled;
    }
  }
}
